import dayjs from 'dayjs';

/**
 * 将时间戳转换为年-月-日格式
 * @param timestamp 10位秒级时间戳
 * @returns 格式化后的日期字符串 YYYY-MM-DD
 */
export const formatTimestamp = (timestamp: number | undefined): string => {
  if (!timestamp || isNaN(timestamp) || timestamp.toString().length !== 10) {
    return '';
  }
  return dayjs.unix(timestamp).format('YYYY-MM-DD');
};
